// 功能開放彈窗 信箱登記

import { useState } from 'react';
import registerClient from '@/common/apiClient/registerClient';

const ComingEmail = ({ t, setStep, showComingModal }) => {
    // 登記信箱
    const [email, setEmail] = useState('');
    const [hint, setHint] = useState(false);

    // 檢查信箱
    const checkMail = () => {
        const pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g;
        return pattern.test(email);
    };

    // 送出
    const onSubmit = async () => {
        if (checkMail()) {
            let result;
            try {
                if (showComingModal === 'SHOP') result = await registerClient.registerShop(email);
                else result = await registerClient.registerForum(email);

                if (result?.message === 'success') setStep(3);
            } catch (e) {
                console.error(e);
            }
        } else {
            setHint(true);
        }
    };

    return (
        <div className="text-center text-white flex w-full h-full relative z-[1] flex-col center-center pt-[3vh]">
            <p className="text-h3">{t('ADULT_STEP_2')}</p>

            <pre className="text-bd1m mt-[2px] mb-[20px]">{t('ADULT_CONTENT_2')}</pre>

            <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('EMAIL_PLACEHOLDER')}
                className="text-btn1 text-black9 placeholder:text-purple1 rounded-[40px] px-[15px] block bg-white mx-auto
                text-center w-[311px] max-w-[94vw] mb-[30px] py-[15px]"
            />

            {hint && <p className="text-btn1 text-white mt-[-15px] mb-[15px]">{t('EMAIL_HINT')}</p>}

            {/* 送出按鈕 */}
            <button
                onClick={onSubmit}
                className="text-btn1b bg-white rounded-[40px] text-plum trans py-[15px] mx-auto w-full max-w-[200px]
            shadow-[0_0_10px_0_rgba(255,255,255,.39)] hover:text-[16px] h-[50px]"
            >
                {t('ADULT_BUTTON_2')}
            </button>
        </div>
    );
};

export default ComingEmail;
